import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    fields: 'flex flex-col gap-6 pb-10',
    row: 'flex items-center justify-between',
    button: 'w-full'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
